<template>
  <div class="view-device">
    <h2>{{ device.manufacturer }} {{ device.model }}</h2>
    <h3 class="text-muted">{{ device.barcode }} - {{ device.serial_number }}</h3>

    <div class="alert alert-warning text-center" v-if="isNotWorking">
      This device is listed as BROKEN or DISPOSED and cannot be assgined or signed out
    </div>

    <dl class="row" v-if="hasActiveDeviceLoan">
      <dt class="col-sm-3 text-right">Status</dt>
      <dd class="col-sm-9">{{ device.status }}</dd>

      <dt class="col-sm-3 text-right">Signed By</dt>
      <dd class="col-sm-9">{{ activeDeviceLoan.name }} ({{ activeDeviceLoan.service_number }})</dd>

      <dt class="col-sm-3 text-right">Contact Number</dt>
      <dd class="col-sm-9">
        <div v-if="activeDeviceLoan.contact_number">{{ activeDeviceLoan.contact_number }}</div>
        <div v-else>None</div>
      </dd>

      <dt class="col-sm-3 text-right">Course</dt>
      <dd class="col-sm-9">
        <router-link :to="{ name: 'ViewCourse', params: { courseId: course.course_id, instanceId: course.id }}">{{ course.course.name }} {{ course.name }}</router-link>
      </dd>

      <dt class="col-sm-3 text-right">Signed For On</dt>
      <dd class="col-sm-9">
        <app-date-time :date-str="activeDeviceLoan.start_date" v-if="activeDeviceLoan.start_date" />
        <span v-else>Awaiting Collection</span>
      </dd>

      <dt class="col-sm-3 text-right">Return By</dt>
      <dd class="col-sm-9">
        <div v-if="course.end_date">
          <app-date :date-str="course.end_date" /> 
          <small class="d-block text-muted" v-if="activeDeviceLoan.extend_to">Extended to <app-date :date-str="activeDeviceLoan.extend_to" /></small>
        </div>
        <app-date :date-str="activeDeviceLoan.extend_to" v-else-if="activeDeviceLoan.extend_to" />
      </dd>
    </dl>

    <dl class="row" v-else>
      <dt class="col-sm-3 text-right">Status</dt>
      <dd class="col-sm-9">{{ device.status }}</dd>

      <dt class="col-sm-3 text-right">Signed By</dt>
      <dd class="col-sm-9">In Stock</dd>
    </dl>

    <div class="text-right" v-if="isWorking">
      <ul class="list-inline">
        <li class="list-inline-item"><router-link class="btn btn-info" target="_blank" :to="{ name: 'DeviceSignoutIndex', params: { deviceBarcode: this.device.barcode } }">View Status</router-link></li>
        <li class="list-inline-item" v-if="hasActiveDeviceLoan"><manual-return :device="device" :loan="activeDeviceLoan">Return</manual-return></li>
        <li class="list-inline-item" v-else><router-link class="btn btn-success" :to="{ name: 'AssignDevice', params: { deviceId: this.device.id } }">Assign Device</router-link></li>
      </ul>
    </div>
    <h2>History</h2>
    <device-loan-history :device-id="device.id" />
  </div>
</template>

<script>
import { xhrState } from '@/components/mixins/xhrState'
import DeviceLoanHistory from '@/components/DeviceLoanHistory/DeviceLoanHistory'
import ManualReturn from '@/components/ManualReturn/ManualReturn'

export default {
  name: 'ViewDevice',
  title: 'View Device',
  mixins: [xhrState],
  components: {
    DeviceLoanHistory,
    ManualReturn
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasActiveDeviceLoan() {
      return !!this.device.active_device_loan
    },
    activeDeviceLoan() {
      if (!this.hasActiveDeviceLoan) return null
      return this.device.active_device_loan
    },
    course() {
      if (!this.hasActiveDeviceLoan) return null
      return this.activeDeviceLoan.instance
    },
    isWorking() {
      return this.device.status === 'WORKING'
    },
    isNotWorking() {
      return !this.isWorking
    }
  }
}
</script>
